import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-studies',
  templateUrl: './studies.component.html',
  styleUrls: ['./studies.component.sass']
})
export class StudiesComponent implements OnInit {
  studies = {
    accomplishments: {
      careers: [
        {
          name: 'Carrera de Arquitectura Frontend',
          logo: 'https://static.platzi.com/media/achievements/Golden-badge-arquitecto-front.png',
          date: 'Online, 2018',
          courses: [
            'Curso de Desarollo Web Online',
            'Curso Profesional de Git y GitHub',
            'Curso de CSS Grid Layout',
            'Curso de Responsive Design',
            'Cursos de Animaciones para la Web',
            'Curso de Sass',
            'Curso de Stylus',
            'Curso de Bootstrap',
            'Curso de PostCSS',
            'Curso de Boots para Messenger'
          ],
          place: 'Platzi - Educación Online Efectiva',
          url: 'https://platzi.com/@juancafelizzola'
        },
        {
          name: 'Carrera Desarrollo con Angular',
          logo: 'https://static.platzi.com/media/achievements/golden_badges-angular-a5634cea-cc0f-41a3-92a7-ff18d0745465.png',
          date: 'Online, 2018',
          courses: [
            'Curso de Angular 4',
            'Curso de Ionic Básico',
            'Curso de Ionic Avanzado',
            'Curso de Angular 6'
          ],
          place: 'Platzi - Educación Online Efectiva',
          url: 'https://platzi.com/@juancafelizzola'
        }
      ]
    }
  }

  constructor() {
    console.log(this.studies);
  }

  ngOnInit() {
  }

}
